// DOCUMENT READY:ANFANG ============================================================================================================
jQuery(document).ready(function ($) {

  /*-- Application SVG ----------------------------------------*/
  (function () {
    var css = {
      '.hover-outline': {
        opacity: 0,
        transition: 'opacity 0.4s'
      },
      '.bubble': {
        transition: 'fill 0.4s, stroke 0.4s'
      },
      '.hover .pulse': {
        display: 'none'
      },

      '#buildings, #trees, #areas > *': {
        opacity: 1,
        transition: 'opacity 1s'
      },
      '.hover #buildings, .hover #trees, .hover #areas > *': {
        opacity: 0.2
      },

      '#areas > * :hover': {
        cursor: 'pointer'
      },
      '.hover #areas > * :hover': {
        cursor: 'auto'
      },
      '#areas > *:hover .hover-outline': {
        opacity: 1
      },
      '#areas > *:hover .bubble': {
        fill: '#cf0000',
        stroke: '#cf0000'
      },
      '.hover #areas > *': {
        "pointer-events": "none"
      },
      '.hover #areas > *:hover .hover-outline': {
        opacity: 0
      },
      '.hover #areas > *:hover .bubble': {
        fill: '#000000',
        stroke: '#ffffff'
      },

      '#areas .active': {
        opacity: 1,
        "pointer-events": "all"
      },
      '.hover #areas > .active :hover': {
        cursor: 'pointer!important'
      },
      '#areas .active .hover-outline, #areas .active:hover .hover-outline': {
        opacity: 1
      },
      '#areas .active .bubble, #areas .active:hover .bubble': {
        fill: '#cf0000',
        stroke: '#cf0000'
      }

    };

    function obj2css(obj) {
      return $.map(obj, function (rules, selector) {
        return selector + '{' + $.map(rules, function (value, key) {
          return key + ':' + value;
        }).join(';') + '}';
      }).join('');
    }

    function s(name, attrs, children) {
      var el = document.createElementNS("https://www.w3.org/2000/svg", name);
      $.each(attrs, function (key, value) {
        el.setAttribute(key, value);
      });
      $.each(Array.prototype.slice.call(arguments, 2), function (key, value) {
        if (typeof value == 'string') {
          $(el).html($(el).html() + value);
        } else {
          el.appendChild(value);
        }
      });
      return el;
    }

    function insertCSS(svg) {
      var style = svg.find('style').eq(0);
      style.text(style.text() + obj2css(css));
    }

    function addTooltip(svg, parent) {
      var tooltip = $('<div class="application-hero-tooltip" />').appendTo($(parent).parent());

      var svgBcr = $('.application-hero .application-svg').get(0).getBoundingClientRect();
      var parentBcr = $('.application-hero .application-svg').get(0).offsetParent.getBoundingClientRect();

      svg.mousemove(function (e) {
        tooltip.css({
          left: e.clientX + svgBcr.left - parentBcr.left + "px",
          top: e.clientY
        });
      });

      return {
        setText: function setText(text) {
          tooltip.text(text.toString());
          return this;
        },
        show: function show() {
          tooltip.addClass('visible');
          return this;
        },
        hide: function hide() {
          tooltip.removeClass('visible');
          return this;
        }
      };
    }

    function initAreas(svg, tooltip, sections, parent) {
      var areas = svg.find('#areas').children();
      areas.hover(function () {
        // svg.attr('class', 'hover');
        if (!svg.hasClass("hover")) {
          tooltip.setText(sections[$(this).attr('id')].name).show();
        }
      }, function () {
        // svg.attr('class', '');
        tooltip.hide();
      }).click(function () {
        var section = sections[$(this).attr('id')];
        location.href = section.link;
      });
    }

    function transitionPulse(el, fromScale, toScale, fromOpacity, toOpacity, duration, callback) {
      $({ foo: 0 }).animate({ foo: 1 }, {
        duration: duration,
        step: function step(val) {
          var scale = +fromScale + (toScale - fromScale) * val;
          el.attr("r", scale * 5.6);
          el.attr("opacity", fromOpacity + (toOpacity - fromOpacity) * val);
        },
        complete: callback
      });
    }

    function pulseBubbles(svg) {
      svg.find('.bubble').each(function () {
        var pulse = s('circle', {
          class: 'pulse',
          fill: '#000000',
          r: $(this).attr('r'),
          cx: $(this).attr('cx'),
          cy: $(this).attr('cy')
        });

        $(pulse).insertBefore(this);
      });

      var pulses = svg.find('.pulse');
      function pulse() {
        var el = pulses.eq(Math.floor(Math.random() * pulses.length));
        transitionPulse(el, 1, 8, 0.6, 0, 2000, function () {
          setTimeout(pulse, 400);
        });
      }
      pulse();
    }

    function positionLabels() {
      var svg = $('.application-hero .application-svg').get(0);
      var svgBcr = svg.getBoundingClientRect();
      var parentBcr = svg.offsetParent.getBoundingClientRect();
      var svgDoc = svg.contentDocument;

      $(".application-label").each(function () {
        var el = svgDoc.getElementById($(this).data('area')).getElementsByClassName("bubble");
        var bcr = el[0].getBoundingClientRect();

        $(this).css({
          opacity: 1,
          left: bcr.left + bcr.width / 2 + svgBcr.left - parentBcr.left + "px",
          top: bcr.top + bcr.height / 2 + svgBcr.top - parentBcr.top + "px"
        });
      });
    }

    function initSVG(el, sections, parent) {
      var svg = $(el.contentDocument).children().eq(0);
      svg.find('title').remove();

      insertCSS(svg);
      var tooltip = addTooltip(svg, parent);
      tooltip.setText('Klassenräume');
      initAreas(svg, tooltip, sections);
      pulseBubbles(svg);
      positionLabels();
      window.addEventListener("resize", positionLabels, { passive: true });
      window.addEventListener("resize", addTooltip(svg, parent), { passive: true });
      initApplicationLabels(el.contentDocument);
    }

    $('.application-hero').each(function (i, el) {
      var sections = {};
      $(this).find('a[data-area]').each(function () {
        sections[$(this).data('area')] = {
          name: $(this).text(),
          link: this.href
        };
      });

      var svg = $(this).find('object').eq(0);
      setTimeout(function () {
        svg.load('"image/svg+xml"', initSVG.bind(this, svg.get(0), sections, svg));
      }, 10);
    });

    /*-- Applikation Buttons Bereiche --*/
    function initApplicationLabels(svgDoc) {
      function hideApplicationLabels() {
        $(".button").removeClass("button--cta");
        $(svgDoc).find("#areas > *").removeClass('active');
        $(".application-label").stop(true).fadeOut();
        $(svgDoc).children().eq(0).removeClass("hover");
      }

      var mappings = {
        'nebenbereiche': 'nebenbereich',
        'hauptbereiche': 'hauptbereich',
        'hauptbereiche-2': 'hauptbereich-2'
      }

      function showLabelsForButton (button) {
        hideApplicationLabels();
        $(svgDoc).children().eq(0).addClass("hover");

        $.each(mappings, function (btnClass, areaClass) {
          if (button.hasClass(btnClass)) {
            button.addClass("button--cta");
            $(svgDoc).find("." + areaClass).addClass('active');
            $(svgDoc).find("." + areaClass + ".active").each(function (i, el) {
              $(".application-label[data-area='" + $(el).attr("id") + "']").stop(true).fadeIn();
            });
          }
        });
      }

      $(".application-hero .button").click(function (e) {
        e.stopPropagation();
        showLabelsForButton($(this));
      });

      $(".application-hero .button:focus").each(function () {
        showLabelsForButton($(this));
      })

      $(window).resize(function () {
        if ($(window).width() < 1200) {
          hideApplicationLabels();
        }
      });

      function onDocumentClick(e) {
        var target = e.currentTarget;
        if (!$(target).closest('.application-hero .button').length) {
          hideApplicationLabels();
        }
      }

      document.addEventListener('click', onDocumentClick);
      svgDoc.addEventListener('click', onDocumentClick);
    }
  })();
});
// DOCUMENT READY:ENDE============================================================================================================


// WEBPACK FOOTER //
// ./js/contentelements/tx-application-stage.js